import '../fonts/fa.scss';

import loginModule from '../scripts/user/login/login.module.ts';

import appDependency from '../scripts/appDependency.js';

appDependency.addItem(loginModule);
